var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.formatted),function(property){return _c('div',{key:property.key},[_c('span',{staticClass:"has-text-weight-bold"},[_vm._v(_vm._s(_vm.$utils.startCase(property.key))+": ")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.nl2br(property.value, false))}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }